export default __webpack_public_path__ + "static/media/1l-inact.22abd950.svg";